import {
  Alert,
  Button,
  CircularProgress,
  Snackbar,
  TextField,
} from "@mui/material";
import React, { useRef, useState } from "react";
import PropTypes from "prop-types";
import { Grid } from "@mui/material";
import { loginUser, loadUser } from "../../actions/AuthActions";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";

function OTP({ loginUser, email, type, otp, verification, setOtp }) {
  const snackRef = useRef(null);
  const [err, setErr] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [state, setState] = useState({
    open: false,
    vertical: "top",
    horizontal: "center",
  });
  const { vertical, horizontal, op } = state;
  const handleClick = (newState) => () => {
    setState({ op: true, ...newState });
  };
  const handleClose = () => {
    setState({ ...state, op: false });
  };
  const navigate = useNavigate();
  const verifyCode = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    try {
      const user = {
        email_address: email,
        type: type,
        otp_code: otp,
        verification: verification,
      };
      const login = await loginUser(user);
      if (login.success) {
        setIsSubmitting(false);

        if (type === "customer_user") {
          navigate("/dashboard/stats");

          return;
        }

        navigate("/dashboard/tasks");
      } else {
        setIsSubmitting(false);
        setErr("Invalid OTP");
        snackRef.current.click();
      }
    } catch (e) {
      setIsSubmitting(false);
      console.log(e);
    }
  };
  return (
    <form onSubmit={verifyCode}>
      <Button
        ref={snackRef}
        style={{ display: "none" }}
        onClick={handleClick({ vertical: "top", horizontal: "center" })}
      >
        Click
      </Button>
      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        open={op}
        onClose={handleClose}
        key={vertical + horizontal}
      >
        {err ? (
          <Alert mt={2} mb={4} severity="error">
            {err}
          </Alert>
        ) : null}
      </Snackbar>
      <Grid container spacing={3}>
        <Grid item xs={12} md={12} lg={12}>
          <TextField
            style={{ margin: "8px 0px" }}
            fullWidth
            value={otp}
            onChange={(e) => setOtp(e.target.value)}
            type="number"
          />
        </Grid>
        <Grid container justifyContent="center" item xs={12} md={12} lg={12}>
          <Button type="submit" size="medium" onClick={verifyCode}>
            {isSubmitting ? (
              <>
                Signing In &nbsp;
                <CircularProgress size={20} color="primary" />
              </>
            ) : (
              "Submit"
            )}
          </Button>
        </Grid>
      </Grid>
    </form>
  );
}

OTP.propTypes = {
  loginUser: PropTypes.func.isRequired,
  auths: PropTypes.object.isRequired,
  loadUser: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  auths: state.auths,
});

export default connect(mapStateToProps, { loginUser, loadUser })(OTP);
